export default "__VITE_ASSET__Bqc3qtci__"